import { useState } from 'react';
import { SwitchInput } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { ConfirmationModal } from './ConfirmationModal';
import { changeContentEntityArchiveStatus } from '@wajeez-web/stores/content';

export const ContentEntityArchive = ({
  archived,
  id,
  onSuccess,
}: {
  archived: boolean;
  id?: string;
  onSuccess?: () => void;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nextStatus, setNextStatus] = useState(archived);

  const handleToggle = (name: string, val: any) => {
    if (!id) return;
    if (val === undefined) return;
    setNextStatus(val);
    setIsModalOpen(true);
  };

  const handleConfirm = async () => {
    if (!id) return;
    setIsLoading(true);
    try {
      await changeContentEntityArchiveStatus({ contentEntityId: id, archived: nextStatus }, onSuccess);
    } finally {
      setIsLoading(false);
      setIsModalOpen(false);
    }
  };

  return (
    <div className="w-full">
      <div className="w-[120px]">
        <SwitchInput
          label={`Archived`}
          checkColor={'green-500'}
          unCheckColor={'red-500'}
          name="publishStatus"
          value={archived}
          onChange={handleToggle}
          loading={false}
          disabled={!id}
        />
      </div>
      <div className="text-xs text-black/70 mt-2 flex justify-start items-center gap-x-1">
        <div>*</div>
        <ReturnTranslatedText text="inputs.disclaimers.content archive" />
      </div>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleConfirm}
        message={`Are you sure you want to ${archived ? 'unarchive' : 'archive'} this content?`}
        isLoading={isLoading}
        widthClassName="w-[500px]"
      />
    </div>
  );
};
